import script from "./PopupReviewPost.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupReviewPost.vue?vue&type=script&setup=true&lang=ts"

import "./PopupReviewPost.vue?vue&type=style&index=0&id=43c0367c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c0367c"]])

export default __exports__